/** MIME + extension allowlist for product BOM Excel uploads. */

export const BOM_IMPORT_XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
export const BOM_IMPORT_XLS_MIME = 'application/vnd.ms-excel'

export const BOM_IMPORT_FILE_ACCEPT =
  `${BOM_IMPORT_XLSX_MIME},${BOM_IMPORT_XLS_MIME},.xlsx,.xls`

function hasAllowedBomImportExtension(fileName: string): boolean {
  const lowerCaseFileName = fileName.toLowerCase()
  return lowerCaseFileName.endsWith('.xlsx') || lowerCaseFileName.endsWith('.xls')
}

function fileNameHasExtension(fileName: string): boolean {
  const trimmed = fileName.trim()
  const lastDot = trimmed.lastIndexOf('.')
  return lastDot > 0 && lastDot < trimmed.length - 1
}

export function isAllowedBomImportFile(file: File): boolean {
  if (fileNameHasExtension(file.name)) {
    return hasAllowedBomImportExtension(file.name)
  }

  return (
    file.type === BOM_IMPORT_XLSX_MIME || file.type === BOM_IMPORT_XLS_MIME
  )
}
